import React from 'react';
import { Popover, Paper, TextField, FormControl, FormLabel, Stack, InputAdornment } from '@mui/material';
import { StaticDatePicker } from '@mui/x-date-pickers';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/nl';

dayjs.extend(LocalizedFormat);
dayjs.locale('nl');

const DatePicker = ({ dateValue, setDateValue, debtorSelected }) => {
  return (
    <PopupState variant="popover" popupId="date-picker-popover">
      {(popupState) => (
        <>
          <Stack direction="row" sx={{ width: '100%' }}>
            <Stack direction="row" alignItems="center" useFlexGap spacing={2} sx={{ width: '100%' }}>
              <FormControl fullWidth sx={{ width: '100%' }}>
                <TextField
                  slotProps={{
                    input: {
                      endAdornment: (
                        <InputAdornment position="end">
                          <CalendarTodayOutlinedIcon sx={{ fontSize: '1rem' }} />
                        </InputAdornment>
                      ),
                    },
                  }}
                  placeholder={dayjs(dateValue || dayjs()).format('D MMMM, YYYY')}
                  label={<FormLabel>Selecteer een datum</FormLabel>}
                  value={dateValue ? dayjs(dateValue).format('D MMMM, YYYY') : ''}
                  disabled={debtorSelected === null}
                  fullWidth
                  {...bindTrigger(popupState)}
                />
              </FormControl>
            </Stack>
          </Stack>

          <Popover
            sx={{
              '& .MuiBackdrop-root': {
                backgroundColor: 'transparent',
              },
            }}
            disableAutoFocus
            {...bindPopover(popupState)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <Paper>
              <StaticDatePicker
                value={dateValue ? dayjs(dateValue) : dayjs()}
                disablePast
                disabled={debtorSelected === null}
                onChange={(newValue) => {
                  setDateValue(newValue || null);
                  popupState.close();
                }}
                autoFocus={false}
                onAccept={(newValue) => {
                  if (newValue) {
                    setDateValue(newValue);
                  }
                  popupState.close();
                }}
                slotProps={{
                  actionBar: {
                    actions: [],
                  },
                  toolbar: {
                    hidden: true,
                  },
                }}
              />
            </Paper>
          </Popover>
        </>
      )}
    </PopupState>
  );
};

export default DatePicker;
